export const PROMOCODES_ROUTE_NAMES = {
    LIST: "PromocodesList",
    CREATE: "PromocodesAdd",
    EDIT: "PromocodesEdit",
};
